import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { Observable, forkJoin, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Docente } from '../models/didattica/docente';
import { AttivitaReale } from '../models/didattica/attivita-reale';
import { RilevazionePresenzeService } from './rilevazione-presenze-service';
import { Studente } from '../models/didattica/studente';
import { Platform } from '@ionic/angular';
import { GeolocUtilityService } from './geolocutility.service';
import { PlatformName } from './env-service/env-platform';
import { Libretto } from '../models/idoneita/libretto';
import { StatoPresenza } from '../models/rilevazione-presenze/presenza';
import { ConfigService } from './config-service/config-service';
import { UtilityService } from './utility.service';
import { ChiaveConfig } from '../models/configurazioni/ChiaveConfig';
import { Corso } from '../models/didattica/corso';

/**
 * Fornisce i servizi relativi alla didattica
 */
@Injectable( { providedIn: 'root' })
export class DidatticaService {

  constructor(public http: HttpClient,
              private rilevazionePresenzeService: RilevazionePresenzeService,
              private geolocUtilityService: GeolocUtilityService,
              private configService: ConfigService,
              private utilityService: UtilityService,
              private platform: Platform) {
    console.log('Hello DidatticaService Provider');
  }

  cercaAttivitaReali(docente: Docente, anno: string = null): Observable<AttivitaReale[]> {

    let url = 'attivitareali/docente/' + docente.id;
    if (anno) {
      url += '/' + anno;
    }
    return this.http.get(url).pipe(map(r => this.parseResponse(r)));
  }

  cercaAttivitaRealiModuli(docente: Docente, anno: string = null): Observable<AttivitaReale[]> {
    const url = 'attivitareali/moduli/docente/' + docente.id + '/' + anno;
    return this.http.get(url).pipe(map(r => this.parseResponse(r)));
  }


/*   cercaAnnoAttivitaRealiConRilevazioni(d: Docente, anno: string): Observable<AttivitaReale[]> {
    return this.http.get('attivitareali/docente/' + d.id + '/' + anno)
    //return this.http.get('attivitareali/docente/' + docente.id)
      .pipe(map(r => this.parseResponse(r)));
  } */

  cercaAttivitaRealiConRilevazioni(d: Docente, anno: string): Observable<AttivitaReale[]> {
    return this.http.get('attivitareali/docente/' + d.id + '/rilevazioni/' + anno)
        .pipe(map(r => this.parseResponse(r)));
  }

  cercaAttivitaRealiSenzaEConRilevazioni(d: Docente): Observable<AttivitaReale[]> {
    return this.http.get('attivitareali/docente/' + d.id + '/rilevazioni/addinsenoril')
      .pipe(map(r => this.parseResponse(r)));
  }

  cercaAttivitaRealiSenzaEConRilevazioniPerAnno(d: Docente, anno: string): Observable<AttivitaReale[]> {
    return this.http.get('attivitareali/docente/' + d.id + '/rilevazioni/addinsenoril/anno/' + anno)
      .pipe(map(r => this.parseResponse(r)));
  }

  cercaAttivitaRealiSenzaEConRilevazioniPrevYear(d: Docente): Observable<AttivitaReale[]> {
    return this.http.get('attivitareali/docente/' + d.id + '/rilevazioni/addinsenoril/prevyear')
      .pipe(map(r => this.parseResponse(r)));
  }

  cercaAttivitaRealiIntegConRilevazioni(d: Docente) {
    return this.http.get('attivitareali/integ/docente/' + d.id + '/rilevazioni')
    .pipe(map(r => this.parseResponse(r)));
  }

  cercaAttivitaRealiIntegConRilevazioniPerAnno(d: Docente, anno: string) {
    return this.http.get('attivitareali/integ/docente/' + d.id + '/rilevazioni/anno/' + anno)
    .pipe(map(r => this.parseResponse(r)));
  }

  cercaAttivitarealiConPresenze(s: Studente, anno: string): Observable<AttivitaReale[]> {
    console.log('cercaAttivitarealiConPresenze ');
    return this.http.get('attivitareali/studente/' + s.id + '/presenze/' + anno)
      // .map(r => r.json())
      .pipe(map(r => this.parseResponse(r)));
  }

  recuperaArConRilevazioni(adLogId: number, checkInteg: string): Observable<AttivitaReale> {
    console.log('cercaAttivitarealiERilevazioni');
    return this.http.get('attivitareali/' + adLogId  + '/' + checkInteg )
      .pipe(map(r => this.parseResponseAr(r)),
       catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throw(error);
        }
      }));
  }

  recuperaArConPresenze(adLogId: number, stuId: number): Observable<AttivitaReale> {
    console.log('cercaAttivitaRealeEPresenzeStudente');
    return this.http.get('attivitareali/' + adLogId + '/studente/' + stuId + '/presenze')
    .pipe(map(r => this.parseResponseAr(r)),
    catchError(error => {
     if (error.status === 404) {
       return of(undefined);
     } else {
       throwError(error);
     }
   }));
  }

  cercaAttivitaRealiRichiesteGiustifica(anno: string): Observable<AttivitaReale[]> {
    const url = 'attivitareali/richiestegiustifica/' + anno;
    return this.http.get(url).pipe(map(r => this.parseResponse(r)));
  }

  cercaInsegnamenti(inse: string, corso: Corso): Observable<AttivitaReale[]> {
    const url = `attivitareali/report?anno=${corso.anno}&inse=${inse}&idCds=${corso.id}&codCds=${corso.codice}`;
    return this.http.get(url)
      .pipe(
        map(r => this.parseReduceResponse(r)),
        catchError(error => {
          if (error.status === 404) {
            return of(undefined);
          } else {
            throwError(() => new Error(error));
          }
        })
      );
  }
  
  

  parseResponseAr(response: any): AttivitaReale {
    const data: AttivitaReale = response;
    return this.toArSmart(data);
  }

  /**
   * parsing della risposta e aggiunta di eventuali metodi di businness
   */
  parseResponse(response: any): AttivitaReale[] {

    // console.log('response', response);

    let json = response; // .json();
    console.log('json', json);

    if (json) {

      if (Array.isArray(json[0])) {
        // se il primo elemento è un array siamo in presenza del prodotto della forkJoin
        // console.log('json 0', json[0]); // AR senza rilevazioni
        // console.log('json 1', json[1]); // AR con rilevazioni
        // json[0].push(json[1]);
        // dal json delle AR senza rilevazioni rimuove quelle che
        // sono presenti nel json con le rilevazioni
        const arSenzaRil: AttivitaReale[] = json[0];
        const arConRil: AttivitaReale[] = json[1];
        for ( let i = 0; i < arSenzaRil.length; i++) {
          if ( this.existsInArray(arConRil, arSenzaRil[i]) ) {
            arSenzaRil.splice(i, 1);
            i--;
            // console.log('arSenzaRil', arSenzaRil);
          }
        }
        json = arConRil.concat(arSenzaRil);
        console.log('json', json);
      }

      const data: AttivitaReale[] = json;
      const result: AttivitaReale[] = [];
      for (const f of data) {
          result.push(f);
          this.toArSmart(f);
      }
      return result;
    } else {
      throw response;
    }

  }
  parseReduceResponse(response: any): AttivitaReale[] {
    const attivita = this.parseResponse(response);
    // rimuove gli afGenIntegDes duplicati per presentare una lista univoca
    // const attivitaRet = Array.from(
    //   new Map(attivita.map(att => [att.afGenIntegDes, att])).values()
    // );

    // filtra solo il record con il responsabile didattico = 1
    const attivitaRet = attivita.filter(att => {
          return (att.docRespDidFlg === 1);
    });

    return attivitaRet;
  }


  toArSmart(f: AttivitaReale) {
    // appiattisce la struttura dell'impegno
    // se trova le informazioni sull'aula e sull'edificio
    if (f.impegnoDocente) {

      if (f.impegnoDocente?.evento?.tipoAttivita) {
          f.impegnoDocente.codTipoAttivita = f.impegnoDocente.evento.tipoAttivita.codice;
          f.impegnoDocente.descTipoAttivita = f.impegnoDocente.evento.tipoAttivita.descrizione;
      }

      if (f.impegnoDocente.risorse) {
        // filtra le risorse individuando le aule
        const _risorse = f.impegnoDocente.risorse.filter(ris => {
          return (ris.aulaId);
        });
        if (_risorse[0]) {
          f.impegnoDocente.aula = _risorse[0].aula;
          f.impegnoDocente.edificio = _risorse[0].aula.edificio;
        }
      }

      // calcola l'indirizzo
      if (f.impegnoDocente.edificio) {
        f.impegnoDocente.edificio.getIndirizzo = function() {
          if (this.via) {
            this.indirizzo = this.via;
          }
          if (this.numeroCivico) {
            this.indirizzo += ' ' + this.numeroCivico;
          }
          if (this.comune) {
            this.indirizzo += ', ' + this.comune;
          }
          if (this.provincia) {
            this.indirizzo += '(' + this.provincia  + ')' ;
          }
          if ( this.indirizzo && this.indirizzo.len < 6 ) {
              this.indirizzo = null;
          }
          return this.indirizzo;
        };
        f.impegnoDocente.edificio.indirizzo = null;
      // se manca l'indirizzo lo recupera dalle coordinate (se presenti)
      if (!f.impegnoDocente.edificio.getIndirizzo() && f.impegnoDocente.edificio.geo ) {

          if (this.platform.is(PlatformName)) {
            this.geolocUtilityService.getAddressMobile(
              f.impegnoDocente.edificio.geo.lat, f.impegnoDocente.edificio.geo.lng, (address) => {
              f.impegnoDocente.edificio.indirizzo = address;
              console.log('address impegno (native) ', f.impegnoDocente.edificio.indirizzo);
            });
          } else {
            this.geolocUtilityService.getAddressBrowser(
              f.impegnoDocente.edificio.geo.lat, f.impegnoDocente.edificio.geo.lng, (address) => {
              f.impegnoDocente.edificio.indirizzo = address;
              console.log('address impegno (web)', f.impegnoDocente.edificio.indirizzo);
            });
          }
        }
        }
      } //
      if (f.impegnoDocente) {
        console.log('f.impegnoDocente', f.impegnoDocente);
      }
    /**
     * implementazione di riepilogoCds()
     */
    f.riepilogoCds = function () {
      const r = [];
      for (const c of this.cds) {
        r.push(c.codice + '-' + c.descrizione);
      }
      return r.join(',');
    };

    f.descrizioneConCds = f.descrizione + ' (' + f.riepilogoCds() + ')';
    if (f.afGenCod) {
      f.descrizioneConCds = f.afGenCod.toUpperCase() + ' - ' + f.descrizioneConCds;
    }
    if (f.docente) {
      f.descrizioneConCdsEDoc = f.descrizioneConCds + ' - ' + f.docente.cognome + ' ' + f.docente.nome;
    }

    if ( !f.totaleMinuti || f.totaleMinuti === 0) {

      /**
       * caso di ar con i dati delle rilevazioni
       * smartizzo le rilevazioni e calcolo il totale erogato
       */
      // console.log('f.rilevazioni', f.rilevazioni);
      if (f.rilevazioni) {
        this.rilevazionePresenzeService.toRilevazioniSmart(f.rilevazioni);
        f.rilevazioni.forEach(r => {
          f.totaleMinuti += this.configService.useExactTimeDocStud ? r.durataReale : r.durata; // ok
        });
      }
    } else {
      if (f.rilevazioni) {
        this.rilevazionePresenzeService.toRilevazioniSmart(f.rilevazioni, false);
      }
    }
    if (f.totaleMinuti) {
      f.totaleMinutiF = this.utilityService.formatDurata(f.totaleMinuti);
      const minRimanenti =  f.ore * 60 - f.totaleMinuti >= 0 ? f.ore * 60 - f.totaleMinuti : f.totaleMinuti - f.ore * 60;
      f.totaleMinutiRimanentiF = this.utilityService.formatDurata(minRimanenti);
    }

    // suddivisioni

    if (f.suddivisioneOre) {

      for (const sudd of f.suddivisioneOre) {
         sudd.oreF = this.utilityService.formatDurata(sudd.ore*60);
         sudd.oreErogateF = this.utilityService.formatDurata(sudd.minErogati? sudd.minErogati: 0);
         sudd.percErog = sudd.minErogati/(sudd.ore*60);
        }

        if (f.rilevazioni && f.suddivisioneOre?.length > 0) {
          let formatSuddivisioneOre = false;
          f.rilevazioni.forEach(r => {
            if (r.tipoAttivita) {
              const oreTA = f.suddivisioneOre.find(sudd => sudd.cod === r.tipoAttivita);
              if (oreTA) {
                oreTA.minErogati += r.durata;
                formatSuddivisioneOre = true;
                }
            }
          });
          if (formatSuddivisioneOre) {
            f.suddivisioneOre.forEach(sudd => {
              sudd.oreErogateF = this.utilityService.formatDurata(sudd.minErogati? sudd.minErogati: 0);
              sudd.percErog = sudd.minErogati/(sudd.ore*60);
            });
          }
        }

        if (f.totaleMinuti > 0) {
          // se non sono state recuperate erogazioni per specifihea suddivisioni 
          // vuol dire che per questo insegnamento sono state 
          // avviate rilevazioni quando il parametro di attivazione della gestione 
          // delle susddivisioni era ancora false 
          // In tal caso le suddivisioni vanno annullate, non potranno essere gestite
          const suddivisioniConErogazioni = f.suddivisioneOre?.find(sudd => sudd.minErogati > 0);
          if (!suddivisioniConErogazioni) {
            f.suddivisioneOre = null;
          }
        }
    }

    /**
     * calcolo del tempo di frequenza dello studente
     * smartizzo le presenze e calcolo il totale
     */
    f.durataInMinuti = 0;
    // console.log('f.presenze', f.presenze);
    if (f.presenze) {


      this.rilevazionePresenzeService.toPresenzeSmart(f.presenze);
      f.presenze.forEach(p => {
      let abusoAsAssenzaFilter = this.configService.getConfigurazione(ChiaveConfig.ABUSO_AS_ASSENZA_FILTER);
      if(abusoAsAssenzaFilter === 'false') {
        if (p.stato === StatoPresenza.PRESENZA || p.stato === StatoPresenza.ABUSO ||
                                   (p.stato === StatoPresenza.ASSENZA && p.giustificata)  ) {
          f.durataInMinuti += p.durata;
        }
      } else {
          if (p.stato === StatoPresenza.PRESENZA || 
                                  (p.stato === StatoPresenza.ASSENZA && p.giustificata)) {
          f.durataInMinuti += p.durata;
        }
      }
     });
    }

    /**
     * la percentuale di lezioni erogate
     */
    f.percentualeLezioni = function () {
      let perc = 0;
      if (f.totaleMinuti > 0) {
        // return parseInt(f.durataTotale(), 10) / (f.ore ? f.ore : parseInt(f.durataTotale(), 10)) ;
        perc = (f.totaleMinuti / 60) / (f.ore ? f.ore : (f.totaleMinuti / 60)) ;
      } else {
        perc = 0;
      }
      return perc;
    };

    /**
     * la percentuale di frequenza dello studente
     */
    f.frequenzaStudente = function() {
      if (f.durataInMinuti > 0) {
        return f.durataInMinuti / f.totaleMinuti ;
      } else {
        return 0;
      }
    };

    if (f.ore) {
      f.oreF = this.utilityService.formatDurata(f.ore * 60);
    }

    if (f.moduliInteg) {
      f.moduliInteg.forEach(m => {
        this.toArSmart(m);
      });

      this.definePercentualeLezioni(f);
    }
    return f;
  }

  definePercentualeLezioni(ar: AttivitaReale) {
    let sommaPerc = 0;
    let percInteg = 0;
    const evalSingleModulesHours = 'true' === this.configService.getConfigurazione(ChiaveConfig.EVAL_SINGLE_MODULE_HOURS);
    if (ar.moduliInteg.length > 0) {
      ar.moduliInteg.forEach(function (modulo) {
        if (evalSingleModulesHours && modulo.totaleMinuti / 60 >= modulo.ore) {
          percInteg = modulo.ore / ar.ore;
        } else {
          percInteg = modulo.totaleMinuti / 60 / ar.ore;
        }
        sommaPerc += percInteg;
      });
      sommaPerc = Math.round(100*sommaPerc)/100;
    }
    if (!evalSingleModulesHours && sommaPerc>1) {
      sommaPerc = 1;
    }

    ar.percentualeLezioni = function () {
      return sommaPerc;
    };

  }
  cercaClasseAttivitaReale(ar: AttivitaReale):  Observable<Libretto[]> {
    let url = 'attivitareali/' + ar.id + '/classe';
    url += ar.moduliInteg && !ar.moduloMonoDisc? '/integ' : '';
    return this.http.get(url)
      .pipe(map(r => this.parseResponseClasse(r)));
  }

  private parseResponseClasse(response: any): Libretto[] {
    if (response instanceof HttpErrorResponse) {
      throw response;
    } else {
      const json = response; // .json();
      const data: Libretto[] = (Array.isArray(json)) ? json : Array.of(json);
      // console.log('classe', data);
      return data;
    }
  }


  existsInArray(arConRil: AttivitaReale[], a: AttivitaReale): boolean {
    for (const ar of arConRil) {
      // console.log(`check ar.id a.id ${ar.id} ${a.id}`);
      if ( a.id === ar.id ) {
        // console.log(`true ar.id a.id ${ar.id} ${a.id}`);
        return true;
      }
    }
    return false;
  }
}
